export default "__VITE_ASSET__CZCpBGAB__"